import React from "react";
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';

import {
	Section,
	SectionLead,
	SectionTitle,
	SectionDescription,
	FlexWrap
} from '../../components/Section'

const ProcessItem = styled.div`
	position: relative;
	width: ${props=> props.width};
	height: 300px;
	margin-bottom: 20px;
	.bg-image {
		position: absolute;
		z-index: 0;
		top: 0;
		left: 0;
		width: 100%;

		.gatsby-image-wrapper {
			width: 100%;
			height: 100%;
		}
	}
	.text {
		position: relative;
		z-index: 2;
		width: 60%;
		margin-left: 40px;
		margin-top: 75px;
		text-align: center;
		font-size: 14px;
	}
	.step {
		position: absolute;
		width: 79px;
		height: 79px;
		border: 5px solid white;
		background: #E43D3C;
		border-radius: 80px;
		z-index: 3;
		top: 5px;
		right: 12%;
		color: white;
		font-size: 30px;
		font-family: 'Eina03-Bold';
		text-align: center;
		padding-top: 20px;
	}
`

const ProcessWrap = styled(FlexWrap)`
	min-height: 400px;
	flex-wrap: wrap;
	justify-content: center;
	max-width: 1300px;
	margin: auto;
	margin-top: 50px;
`

const ProcessSection = ({ data }) => (
	<Section pb="0">
		<div className="container">
			<SectionLead color="#E43D3C">{data.label}</SectionLead>
			<SectionTitle>{data.title}</SectionTitle>
			<SectionDescription maxWidth="890px">{data.description}</SectionDescription>
			<ProcessWrap>
				{
					data.process.map((item, i) => {
						const length = data.process.length;
						if (i < length - 1) {
							return(
								<ProcessItem width="300px">
									<div className="bg-image">
										<StaticImage
							        src="../../images/financing-process.png"
							        placeholder="blurred"
							        quality={95}
							        alt="review hero"
							      />
									</div>
									<div className="step">
										{item.step}
									</div>
									<div className="text">
										{item.description}
									</div>
								</ProcessItem>
							)
						}	else {
							return(
								<ProcessItem width="275px">
									<div className="bg-image">
										<StaticImage
							        src="../../images/financing-last-process.png"
							        placeholder="blurred"
							        quality={95}
							        alt="review hero"
							      />
									</div>
									<div className="step">
										{item.step}
									</div>
									<div className="text">
										{item.description}
									</div>
								</ProcessItem>
							)
						}
					})
				}
			</ProcessWrap>
		</div>
	</Section>
);

export default ProcessSection;